export default "__VITE_ASSET__DDC8chGZ__"